const PLACEHOLDER_PATTERN = /{{\s*([^}]+?)\s*}}/g;

const getValueByPath = (path, context = {}) => path.split('.').reduce((value, key) => {
  if (value == null) return undefined;
  return value[key];
}, context);

const resolvePlaceholders = (template = '', context = {}) => template.replace(PLACEHOLDER_PATTERN, (_, rawKey) => {
  const key = rawKey.trim();
  if (key === 'today') {
    return new Date().toISOString().slice(0, 10);
  }

  const value = getValueByPath(key, context);
  if (value == null || value === '') {
    return `[missing: ${key}]`;
  }

  return String(value);
});

export default resolvePlaceholders;
